//Models
PJQ.models.auth = {};

//Collections
PJQ.collections.auth = {};

//Views
PJQ.views.auth = {};

PJQ.views.auth.SignIn = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Sign-In')
	},
	events: {
		'keydown .input-username,.input-password': 'loginChanged',
		'click .btn-sign-in': 'signInClicked',
		'click .btn-forgot-password': 'forgotPassword'
	},
	renderData: function () {
		return {
			username: this.username,
			options: this.options
		};
	},
	loginChanged: function (e) {
		if (e.which === 13) {
			e.preventDefault();
			if (PJQ.app.TokenManager != null && PJQ.app.TokenManager.enabled) {
				this.signInToken();
			}
			else {
				this.signIn();
			}
			return false;
		}
	},
	signInClicked: function () {
		if (PJQ.app.TokenManager != null && PJQ.app.TokenManager.enabled) {
			this.signInToken();
		}
		else {
			this.signIn();
		}
	},
	signInToken: function () {
		if (this.errorAlert) {
			this.errorAlert.destroy();
		}

		let $btnSignIn = this.$('.btn-sign-in');
		$btnSignIn.prop('disabled', true);


		if(this.$('.input-username').length > 0 && !this.isUsernameSSO){
			this.username = this.$('.input-username').val();
		}

		if (this.options.isSSO && this.isUsernameSSO !== false) {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'saml'
					}
				], [
					{
						parameter: 'username',
						value: this.username
					}
				])
			}).get().done(_.bind(function (data) {
				if (data.enabled) {
					window.location.href = data.signOnUrl;
				}
				else {
					this.isUsernameSSO = false;
					this.render();
				}
			}, this)).fail(_.bind(function () {
				this.renderError(PJQ.Errors.auth["CUSTOMER_SERVICE"]);
			}, this));
		}
		else {
			let password = this.$('.input-password').val();
			if (_.size(this.username) === 0 || _.size(password) === 0)
				return;

			PJQ.app.TokenManager.getTokensForUser(this.username, password, _.bind(function(success, error){
				if(success){
					let accessKey = PJQ.app.session.get('accessKey');
					if (_.size(accessKey) > 0) {
						PJQ.app.session.fetch({
							success: function () {
								PJQ.helpers.projectHelpers.accessKeyNavigate(accessKey, _.bind(function (err) {
									if (err != null) {
										this.renderError(err);
									}
								}, this));
							}
						});
					}
					else {
						let loc = '/';
						if (PJQ.app.module === PJQ.constants.modules.APP) {
							if (_.size(PJQ.app.router.signInCache) > 0) {
								loc += PJQ.app.router.signInCache;
								PJQ.app.router.signInCache = null;
								window.location.replace(loc);
							}
							window.location.reload();
						}
						else {
							window.location = loc;
						}
					}
				}
				else{
					$btnSignIn.prop('disabled', false);
					if (error === 'EXPIRED' || error === 'EXPIRED_PASSWORD') {
						new PJQ.ajax.Request({
							endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
								{
									endpoint: 'users'
								},
								{
									endpoint: 'resetpassword',
									value: data.passwordResetGuid
								},
							])
						}).get().done(function (request) {
							new PJQ.views.auth.ResetPasswordModal({
								request: request,
								isExpired: true,
								isContinueToSignIn: false
							});
						}).fail(_.bind(function () {
							this.renderError(PJQ.Errors.auth["CUSTOMER_SERVICE"]);
						}, this));
					}
					else {
						let errorText;
						if (_.size(error) > 0 && (error.toUpperCase() === "LOCKED" || error.toUpperCase() === "LOCKED_USER")) {
							if (error.lockoutMinutes > 0) {
								errorText = "Your account has been locked for " + error.lockoutMinutes.toString() + " minutes due to too many failed attempts";
							}
							else if (_.size(error) > 0) {
								errorText = PJQ.Errors.auth[error.toUpperCase()];
							}
							else {
								errorText = PJQ.Errors.auth["CUSTOMER_SERVICE"];
							}
						}
						else if (_.size(error) > 0) {
							errorText = PJQ.Errors.auth[error.toUpperCase()];
						}
						else {
							errorText = PJQ.Errors.auth["CUSTOMER_SERVICE"];
						}
						if (this.options.isSSO) {
							this.username = null;
							this.isUsernameSSO = null;
							this.initError = errorText;
							this.render();
						}
						else {
							this.renderError(errorText);
						}
					}
				}
			}, this));
		}
	},
	signIn: function () {
		if (this.errorAlert) {
			this.errorAlert.destroy();
		}

		let $btnSignIn = this.$('.btn-sign-in');
		$btnSignIn.prop('disabled', true);

		if (_.size(this.username) === 0) {
			this.username = this.$('.input-username').val();
		}

		if (this.options.isSSO && this.isUsernameSSO !== false) {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'saml'
					}
				], [
					{
						parameter: 'username',
						value: this.username
					}
				])
			}).get().done(_.bind(function (data) {
				if (data.enabled) {
					window.location.href = data.signOnUrl;
				}
				else {
					this.isUsernameSSO = false;
					this.render();
				}
			}, this)).fail(_.bind(function () {
				this.renderError(PJQ.Errors.auth["CUSTOMER_SERVICE"]);
			}, this));
		}
		else {
			let password = this.$('.input-password').val();
			if (_.size(this.username) === 0 || _.size(password) === 0)
				return;

			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'signin'
					}
				]),
				data: {
					username: this.username,
					password: password
				}
			}).post().done(_.bind(function (data) {
				if (data.success) {
					let remember = this.$('.input-remember').prop('checked');
					PJQ.helpers.cookieHelpers.setCookie(".DOTNETNUKE", data.cookie, remember ? 0 : null);
					PJQ.helpers.cookieHelpers.setCookie("SessionId", data.sessionId);

					let fnRedirect = _.bind(function () {
						let accessKey = PJQ.app.session.get('accessKey');
						if (_.size(accessKey) > 0) {
							PJQ.app.session.fetch({
								success: function () {
									PJQ.helpers.projectHelpers.accessKeyNavigate(accessKey, _.bind(function (err) {
										if (err != null) {
											this.renderError(err);
										}
									}, this));
								}
							});
						}
						else {
							let loc = '/';
							if (PJQ.app.module === PJQ.constants.modules.APP) {
								if (_.size(PJQ.app.router.signInCache) > 0) {
									loc += PJQ.app.router.signInCache;
									PJQ.app.router.signInCache = null;
									window.location.replace(loc);
								}
								window.location.reload();
							}
							else {
								window.location = loc;
							}
						}
					}, this);

					if (1 === 2) {
						new PJQ.ajax.Request({
							endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
								{
									endpoint: 'token'
								}
							], [
								{
									parameter: 'username',
									value: this.username
								},
								{
									parameter: 'password',
									value: password
								}
							]),
							isAPIv2: true
						}).get().done(_.bind(function (data) {
							// new PJQ.ajax.Request({
							// 	endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
							// 		{
							// 			endpoint: 'Token.aspx'
							// 		}
							// 	], [
							// 		{
							// 			parameter: 'r',
							// 			value: data.refresh_token
							// 		}
							// 	]),
							// 	isOrigin: true
							// }).get().done(_.bind(function () {
							// 	fnRedirect();
							// }));
							fnRedirect();
						}));
					}
					else {
						fnRedirect();
					}
				}
				else {
					$btnSignIn.prop('disabled', false);
					if (data.error === 'EXPIRED') {
						new PJQ.ajax.Request({
							endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
								{
									endpoint: 'users'
								},
								{
									endpoint: 'resetpassword',
									value: data.passwordResetGuid
								},
							])
						}).get().done(function (request) {
							new PJQ.views.auth.ResetPasswordModal({
								request: request,
								isExpired: true,
								isContinueToSignIn: false
							});
						}).fail(_.bind(function () {
							this.renderError(PJQ.Errors.auth["CUSTOMER_SERVICE"]);
						}, this));
					}
					else {
						let errorText;
						if (data.error === "LOCKED") {
							if (data.lockoutMinutes === -1) {
								errorText = "Your account has been locked due to too many failed attempts";
							}
							else if (data.lockoutMinutes > 0) {
								errorText = "Your account has been locked for " + data.lockoutMinutes.toString() + " minutes due to too many failed attempts";
							}
							else {
								errorText = PJQ.Errors.auth[data.error];
							}
						}
						else {
							errorText = PJQ.Errors.auth[data.error];
						}
						if (this.options.isSSO) {
							this.username = null;
							this.isUsernameSSO = null;
							this.initError = errorText;
							this.render();
						}
						else {
							this.username = null;
							this.renderError(errorText);
						}
					}
				}
			}, this)).fail(_.bind(function (xhr, err, result) {
				this.username = null;
				this.renderError(PJQ.Errors.auth.UNHANDLED);
				new PJQ.logging.Debug(PJQ.logging.LoggingActions.AUTH_SIGN_IN, {
					error: err,
					result: result
				});
			}, this));
		}
	},
	forgotPassword: function () {
		new PJQ.views.auth.RequestResetPasswordModal();
	},
	renderError: function (error) {
		this.$('.btn-sign-in').prop('disabled', false);
		this.errorAlert = new PJQ.Alert(this.$('.error-container'), {
			type: 'danger',
			text: error
		});
	}
});

PJQ.views.auth.AccessKeySignIn = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Sign-In-Access-Key')
	},
	events: {
		'keydown .input-access-key': 'accessKeyChanged',
		'paste .input-access-key': 'accessKeyPasted',
		'click .btn-access-key-sign-in': 'signIn'
	},
	accessKeyPasted: function (e) {
		if (typeof navigator !== 'undefined' && e.originalEvent.clipboardData && e.originalEvent.clipboardData.getData) {
			navigator.permissions.query({
				name: 'clipboard-read'
			}).then(permissionStatus => {
				if (permissionStatus.state === 'granted') {
					e.preventDefault();
					let pastedText = e.originalEvent.clipboardData.getData('text/plain');

					setTimeout(_.bind(function () {
						this.$('.input-access-key').val(pastedText.replace(/\s|\t/g, ''));
					}, this), 100);
				}
				else {
					setTimeout(_.bind(function () {
						this.$('.input-access-key').val(this.$('.input-access-key').val().replace(/\s|\t/g, ''));
					}, this), 100);
				}
			});
		}
		else if (window.clipboardData && window.clipboardData.getData) {
			e.preventDefault();

			//IE browser OnPaste Event Handler
			let pastedText = window.clipboardData.getData('Text');
			setTimeout(_.bind(function () {
				this.$('.input-access-key').val(pastedText.replace(/\s|\t/g, ''));
			}, this), 100);
		}
	},
	accessKeyChanged: function (e) {
		if (e.which === 13) {
			if (PJQ.app.TokenManager != null && PJQ.app.TokenManager.enabled) {
				this.signInToken();
			}
			else {
				this.signIn();
			}
			e.preventDefault();
			return false;
		}
	},
	signIn: function () {
		if (this.errorAlert) {
			this.errorAlert.destroy();
		}

		let accessKey = this.$('.input-access-key').val();
		if (_.size(accessKey) !== 10) {
			this.renderError(PJQ.Errors.auth.KEY_LENGTH);
			return;
		}

		this.$('.btn-sign-in').prop('disabled', true);

		if (PJQ.app.module === PJQ.constants.modules.APP) {
			PJQ.helpers.projectHelpers.accessKeyNavigate(accessKey, _.bind(function (err) {
				if (err != null) {
					this.renderError(err);
				}
				this.$('.btn-sign-in').prop('disabled', false);
			}, this));
		}
		else {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'v1'
					},
					{
						endpoint: 'accessKeys',
						value: accessKey
					}
				])
			}).get().done(_.bind(function (response) {
				if (response.indexOf('Default.aspx') !== -1) {
					window.location = response;
				}
				else if (response.indexOf('/') !== -1) {
					window.location = response.substring(1);
				}
				else {
					this.renderError(PJQ.Errors.auth.NOT_FOUND);
				}
			}, this)).fail(_.bind(function (xhr, err, result) {
				this.renderError(PJQ.Errors.auth.UNHANDLED);
				this.$('.btn-sign-in').prop('disabled', false);
				new PJQ.logging.Debug(PJQ.logging.LoggingActions.AUTH_SIGN_IN, {
					error: err,
					result: result
				});
			}, this));
		}
	},
	renderError: function (error) {
		this.$('.btn-sign-in').prop('disabled', false);
		this.errorAlert = new PJQ.Alert(this.$('.error-container-access-key'), {
			type: 'danger',
			text: error
		});
	}
});

PJQ.views.auth.AuthModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-auth'),
		isVerticalCenter: true
	},
	events: {},
	afterRender: function () {
		new PJQ.views.auth.Auth(_.defaults(_.omit(this.options, 'template'), {
			el: this.$('.modal-body'),
			model: this.model
		}));
	}
});

PJQ.views.auth.Auth = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'auth'),
		defaultSignUpUsername: '',
		routeToRoot: false
	},
	modes: {
		SIGN_IN: 'SIGN_IN',
		SIGN_UP: 'SIGN_UP',
		RESET_PASSWORD: 'RESET_PASSWORD',
		RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS'
	},
	events: {
		'click .auth-nav-sign-in': 'renderSignIn',
		'keyup .auth-sign-in-username': 'signInUsernameChanged',
		'keyup .auth-sign-in-password': 'signInPasswordChanged',
		'click .auth-sign-in': 'signIn',
		'click .auth-nav-sign-up': 'renderSignUp',
		'keyup .input-sign-up-username': 'signUpUsernameChanged',
		'keyup .input-sign-up-password': 'signUpPasswordChanged',
		'click .btn-sign-up': 'signUp',
		'click .auth-nav-reset-password': 'renderResetPassword',
		'keyup .auth-reset-password-username': 'resetUsernameChanged',
		'click .auth-reset-password': 'resetPassword'
	},
	beforeFirstRender: function () {
		let errorParam = PJQ.helpers.urlHelpers.getQueryParam("err", true);
		if (_.size(errorParam) > 0) {
			this.initError = PJQ.Errors.auth[errorParam.toUpperCase()];
		}

		this.model = new PJQ.models.users.User();

		let sessionContact = PJQ.app.session.contact;
		if (sessionContact != null) {
			this.model.set({
				companyName: sessionContact.get('companyName'),
				contactName: sessionContact.get('contactName'),
				email: sessionContact.get('email')
			});
		}
	},
	beforeRender: function () {
		if (this.options.mode == null) {
			this.options.mode = this.modes.SIGN_IN
		}
	},
	renderData: function () {
		return {
			model: this.model,
			options: this.options,
			modes: this.modes
		};
	},
	afterRender: function () {
		if (this.initError != null) {
			this.renderSignInError(this.initError);
			this.initError = null;
		}

		new PJQ.Binder(this.$('.auth-sign-up'), this.model, {
			watchElements: [
				'input'
			]
		});
	},
	renderSignIn: function () {
		this.options.mode = this.modes.SIGN_IN;
		this.render();
	},
	signInUsernameChanged: function (e) {
		if (e.keyCode === 13) {
			this.$('.auth-sign-in-password').focus();
		}
	},
	signInPasswordChanged: function (e) {
		if (e.keyCode === 13) {
			if (PJQ.app.TokenManager != null && PJQ.app.TokenManager.enabled) {
				this.signInToken();
			}
			else {
				this.signIn();
			}
		}
	},
	renderSignInError: function (error) {
		this.signInAlert = new PJQ.Alert(this.$('.sign-in-error-container'), {
			type: 'danger',
			text: error
		});
		this.$('.auth-sign-in').prop('disabled', false).text('Sign In');
	},
	signIn: function () {
		let username = this.$('.auth-sign-in-username').val(),
			password = this.$('.auth-sign-in-password').val();

		if (_.size(username) === 0 || _.size(password) === 0)
			return;

		this.$('.auth-sign-in').prop('disabled', true).text('Signing In...');

		if (this.signInAlert) {
			this.signInAlert.destroy();
		}

		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'signin'
				}
			]),
			data: {
				username: username,
				password: password
			}
		}).post().done(_.bind(function (data) {
			if (data.success) {
				PJQ.helpers.cookieHelpers.setCookie(".DOTNETNUKE", data.cookie);
				PJQ.helpers.cookieHelpers.setCookie("SessionId", data.sessionId);
				if (this.options.routeToRoot) {
					window.location.href = '/';
				}
				else {
					location.reload();
				}
			}
			else {
				this.renderSignInError(PJQ.Errors.auth[data.error]);
			}
		}, this)).fail(_.bind(function (xhr, err, result) {
			this.renderSignInError(PJQ.Errors.auth.UNHANDLED);
			new PJQ.logging.Debug(PJQ.logging.LoggingActions.AUTH_SIGN_IN, {
				error: err,
				result: result
			});
		}, this));
	},
	renderSignUp: function () {
		this.options.mode = this.modes.SIGN_UP;
		this.render();
	},
	signUpUsernameChanged: function (e) {
		this.validateSignUpInfo();
		if (e.keyCode === 13) {
			this.$('.input-sign-up-password').focus();
		}
	},
	signUpPasswordChanged: function (e) {
		this.validateSignUpInfo();
		if (e.keyCode === 13) {
			this.signUp();
		}
	},
	validateSignUpInfo: function () {
		let usernameLength = _.size(this.$('.input-sign-up-username').val()),
			passwordLength = _.size(this.$('.input-sign-up-password').val());
		this.$('.btn-sign-up').prop('disabled', usernameLength === 0 || passwordLength === 0);
	},
	signUp: function () {
		let username = this.$('.input-sign-up-username').val(),
			password = this.$('.input-sign-up-password').val();

		if (_.size(username) === 0 || _.size(password) === 0)
			return;

		this.$('.btn-sign-up').prop('disabled', true).text('Signing Up...');

		if (this.signUpAlert) {
			this.signUpAlert.destroy();
		}

		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'signup'
				}
			]),
			data: {
				companyName: this.model.get('companyName'),
				contactName: this.model.get('contactName'),
				email: this.model.get('email'),
				username: username,
				password: password
			}
		}).post().done(_.bind(function (data) {
			if (data.success) {
				PJQ.helpers.cookieHelpers.setCookie(".DOTNETNUKE", data.cookie);
				PJQ.helpers.cookieHelpers.setCookie("SessionId", data.sessionId);
				if (this.options.routeToRoot) {
					window.location.href = '/';
				}
				else {
					location.reload();
				}
			}
			else {
				this.renderSignUpError(PJQ.Errors.auth[data.error]);
			}
		}, this)).fail(_.bind(function (xhr, err, result) {
			this.renderSignUpError(PJQ.Errors.auth.CUSTOMER_SERVICE);
			new PJQ.logging.Debug(PJQ.logging.LoggingActions.AUTH_SIGN_UP, {
				error: err,
				result: result
			});
		}, this));
	},
	renderSignUpError: function (error) {
		this.signUpAlert = new PJQ.Alert(this.$('.sign-up-error-container'), {
			type: 'danger',
			text: error
		});
		this.$('.btn-sign-up').prop('disabled', false).text('Sign Up');
	},
	renderResetPassword: function () {
		this.options.mode = this.modes.RESET_PASSWORD;
		this.render();
	},
	resetUsernameChanged: function (e) {
		this.validateResetPasswordInfo();
		if (e.keyCode === 13) {
			this.resetPassword();
		}
	},
	validateResetPasswordInfo: function () {
		let usernameLength = _.size(this.$('.auth-reset-password-username').val());
		this.$('.auth-reset-password').prop('disabled', usernameLength === 0);
	},
	resetPassword: function () {
		let username = this.$('.auth-reset-password-username').val();

		if (_.size(username) === 0)
			return;

		this.$('.auth-reset-password').prop('disabled', true).text('Trying...');

		if (this.resetPasswordAlert) {
			this.resetPasswordAlert.destroy();
		}

		PJQ.helpers.users.sendPasswordReset(username, _.bind(function (result) {
			if (result.success) {
				this.renderResetPasswordSuccess();
			}
			else {
				this.renderResetPasswordError(result.error);
			}
		}, this));
	},
	renderResetPasswordSuccess: function () {
		this.options.mode = this.modes.RESET_PASSWORD_SUCCESS;
		this.render();
	},
	renderResetPasswordError: function (error) {
		this.resetPasswordAlert = new PJQ.Alert(this.$('.reset-password-error-container'), {
			type: 'danger',
			text: error
		});
		this.$('.auth-reset-password').prop('disabled', false).text('Reset Password');
	}
});

PJQ.views.auth.ResetPasswordModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Reset-Password'),
		isVerticalCenter: true,
		isExpired: false,
		isContinueToSignIn: true
	},
	events:{
		'click .auth-nav-sign-in': 'navSignIn'
	},
	beforeRender: function () {
		this.options.isShowCloseButton = this.options.isExpired;
		this.renderData = {
			options: this.options,
			error: this.options.error ? (PJQ.Errors.auth[this.options.error] ? PJQ.Errors.auth[this.options.error] : PJQ.Errors.auth.CUSTOMER_SERVICE) : null
		};
	},
	afterRender: function () {
		if (this.options.request != null) {
			new PJQ.views.auth.ResetPassword({
				el: this.$('.reset-password-view'),
				request: this.options.request,
				onReset: _.bind(function () {
					this.options.request = null;
					this.options.success = true;
					this.render();
				}, this)
			});
		}
	},
	navSignIn: function(){
		this.removeModal();
		PJQ.app.router.signInNavigate();

	}
});

PJQ.views.auth.ResetPassword = PJQ.views.BaseView.extend({
	baseOptions: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Reset-Password'),
		subTemplates: {
			passwordRequirements: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Password-Requirements')
		},
		isRequirementsGrid: true
	},
	events: {
		'keyup .input-reset-password': 'passwordChanged',
		'click .btn-reset-password': 'resetPassword'
	},
	beforeRender: function () {
		this.renderData = {
			options: this.options,
			passwordRequirements: this.options.request ? this.options.request.passwordRequirements : null,
			error: this.options.error ? (PJQ.Errors.auth[this.options.error] ? PJQ.Errors.auth[this.options.error] : PJQ.Errors.auth.CUSTOMER_SERVICE) : null
		};
	},
	afterRender: function () {
		this.renderPasswordRequirements();

		this.$('.input-reset-password')[0].focus();
		if (this.options.request != null) {
			this.checkPasswordRequirements();
		}
	},
	renderPasswordRequirements: function () {
		this.renderSubTemplate(false, this.options.subTemplates.passwordRequirements, this.$('.password-requirements'), {
			isGrid: this.options.isRequirementsGrid,
			passwordRequirements: this.options.request ? this.options.request.passwordRequirements : null,
		});
	},
	checkPasswordRequirements: function () {
		let req = this.options.request.passwordRequirements,
			newPassword = this.$('.input-reset-password').val(),
			validCheck = true;

		let $maxLength = this.$('.password-req-length-max');
		if (_.size(newPassword) > 38) {
			validCheck = false;
			$maxLength.addClass('op-6');
		}
		else {
			$maxLength.removeClass('op-6');
		}

		if (!req.allowRepeatChars) {
			let $noRepeat = this.$('.password-req-no-repeat'),
				arr = newPassword.split('');
			if (_.size(arr) === 0 || arr.some(function (v, i, a) {
				return a.lastIndexOf(v) !== i;
			})) {
				validCheck = false;
				$noRepeat.addClass('op-6');
			}
			else {
				$noRepeat.removeClass('op-6');
			}
		}

		if (req.minLength > 0) {
			let $length = this.$('.password-req-length');
			if (_.size(newPassword) < req.minLength) {
				validCheck = false;
				$length.addClass('op-6');
			}
			else {
				$length.removeClass('op-6');
			}
		}

		if (req.lowercaseCount > 0) {
			let $lowercase = this.$('.password-req-lowercase');
			if (_.size(PJQ.helpers.stringHelpers.getLowercaseChars(newPassword)) < req.lowercaseCount) {
				validCheck = false;
				$lowercase.addClass('op-6');
			}
			else {
				$lowercase.removeClass('op-6');
			}
		}

		if (req.uppercaseCount > 0) {
			let $uppercase = this.$('.password-req-uppercase');
			if (_.size(PJQ.helpers.stringHelpers.getUppercaseChars(newPassword)) < req.uppercaseCount) {
				validCheck = false;
				$uppercase.addClass('op-6');
			}
			else {
				$uppercase.removeClass('op-6');
			}
		}

		if (req.numericCount > 0) {
			let $numeric = this.$('.password-req-numeric');
			if (_.size(PJQ.helpers.stringHelpers.getNumericChars(newPassword)) < req.numericCount) {
				validCheck = false;
				$numeric.addClass('op-6');
			}
			else {
				$numeric.removeClass('op-6');
			}
		}

		if (req.specialCharCount > 0) {
			let $special = this.$('.password-req-special-char');
			if (_.size(PJQ.helpers.stringHelpers.getSpecialChars(newPassword)) < req.specialCharCount) {
				validCheck = false;
				$special.addClass('op-6');
			}
			else {
				$special.removeClass('op-6');
			}
		}
		this.isValid = validCheck;
	},
	passwordChanged: function (e) {
		this.checkPasswordRequirements();
		this.$('.btn-reset-password').prop('disabled', !this.isValid);
		if (e.keyCode === 13 && this.isValid) {
			this.resetPassword();
		}
	},
	resetPassword: function () {
		if (this.errorAlert != null) {
			this.errorAlert.destroy();
		}

		if (!this.isValid)
			return;

		this.$('.btn-reset-password').prop('disabled', true).text('Trying...');

		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'users'
				},
				{
					endpoint: 'resetpassword',
					value: this.options.request.guid
				},
			]),
			data: {
				password: this.$('.input-reset-password').val()
			}
		}).post().success(_.bind(function (data) {
			if (data.success) {
				this.options.success = true;
				this.options.request = null;
				this.onReset();
			}
			else {
				this.$('.btn-reset-password').prop('disabled', false).text('Change Password');
				if (data.error === 'ALREADY_USED') {
					this.renderError("You cannot use your last " + this.options.request.passwordRequirements.historyPreventCount.toString() + " passwords.");
				}
				else {
					this.renderError(PJQ.Errors.auth[data.error]);
				}
			}
		}, this)).fail(_.bind(function () {
			this.options.success = false;
			this.render();
		}, this));
	},
	onReset: function () {
		if (typeof this.options.onReset === 'function') {
			this.options.onReset();
		}
		else {
			this.render();
		}
	},
	renderError: function (error) {
		this.errorAlert = new PJQ.Alert(this.$('.error-container'), {
			type: 'danger',
			text: error
		});
	}
});

PJQ.views.auth.RequestResetPasswordModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Request-Reset-Password'),
		isVerticalCenter: true,
		isShowCloseButton: true
	},
	events: {
		'keyup .input-reset-password-username': 'usernameChanged',
		'click .btn-reset-password': 'resetPassword'
	},
	beforeRender: function () {
		this.renderData = {
			success: this.success
		};
	},
	afterRender: function () {
		let $username = this.$('.input-reset-password-username');
		if (_.size($username) > 0) {
			$username[0].focus();
		}
	},
	usernameChanged: function (e) {
		this.$('.btn-reset-password').prop('disabled', _.size(this.$('.input-reset-password-username').val()) === 0);
		if (e.keyCode === 13) {
			this.resetPassword();
		}
	},
	resetPassword: function () {
		let username = this.$('.input-reset-password-username').val();

		if (_.size(username) === 0)
			return;

		this.$('.btn-reset-password').prop('disabled', true).text('Trying...');

		if (this.resetPasswordAlert) {
			this.resetPasswordAlert.destroy();
		}

		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'users'
				},
				{
					endpoint: 'requestpasswordreset'
				}
			], [
				{
					parameter: 'masterUserId',
					value: PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId')
				},
				{
					parameter: 'username',
					value: username
				}
			])
		}).post().done(_.bind(function (data) {
			if (data.success) {
				this.success = true;
				this.render();
			}
			else {
				this.renderError(PJQ.Errors.auth[data.error]);
			}
		}, this)).fail(_.bind(function (xhr, err, result) {
			this.renderError(PJQ.Errors.auth.CUSTOMER_SERVICE);
			new PJQ.logging.Debug(PJQ.logging.LoggingActions.AUTH_RESET_PASSWORD, {
				error: err,
				result: result
			});
		}, this));
	},
	renderError: function (error) {
		this.resetPasswordAlert = new PJQ.Alert(this.$('.reset-password-error-container'), {
			type: 'danger',
			text: error
		});
		this.$('.btn-reset-password').prop('disabled', false).text('Reset Password');
	}
});

PJQ.views.auth.AppSignIn = PJQ.views.auth.SignIn.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Sign-In')
	},
	events: {
		'keydown .input-username,.input-password': 'loginChanged',
		'click .btn-sign-in': 'signInClicked',
		'click .btn-sign-up-nav': 'signUpNavigate',
		'click .btn-forgot-password': 'forgotPassword'
	},
	beforeFirstRender: function () {
		let errorParam = PJQ.helpers.urlHelpers.getQueryParam("err", true);
		if (_.size(errorParam) > 0) {
			this.initError = PJQ.Errors.auth[errorParam.toUpperCase()];
		}

		PJQ.helpers.setViewport("width=device-width, initial-scale=1, minimum-scale=1");
		this.options.isSSO = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_SSO_ENABLED);
	},
	afterRender: function () {
		if (this.initError != null) {
			this.renderError(this.initError);
			this.initError = null;
		}

		if (this.options.isSSO && _.size(this.username) > 0) {
			this.$('.input-password')[0].focus();
		}
		else {
			this.$('.input-username')[0].focus();
		}

		this.accessKeySignIn = new PJQ.views.auth.AccessKeySignIn({
			el: this.$('.access-key-sign-in'),
			template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Sign-In-Access-Key')
		});

		if (PJQ.app.session.isPanteraPortal()) {
			this.initFeatureAds();
		}
	},
	signUpNavigate: function () {
		//2024-05-23 blue: Redirect all signups to new subcontractor registration page.   GCs cannot register on panteratools until we provide an alternate path.
		if (PJQ.app.session.isPanteraPortal()) {
			window.location.href = 	'https://app.panteratools.com/Default.aspx?tabid=10205';
		} else {
			PJQ.app.router.navigate('signup', {
				trigger: true
			});
		}
	},
	initFeatureAds: function () {
		let features = PJQ.helpers.auth.features();
		if (_.size(features) > 0) {
			let feature = features[Math.floor(Math.random() * _.size(features))];
			this.renderSubTemplate(false, feature, this.$('.app-sign-in-features'), {}, _.bind(function(){
				if(feature.file === 'app-sign-in-carousel'){
					this.$('.carousel').carousel({
						interval: 4300,
						ride: 'carousel'
					})
				}
			}, this));
		}
	}
});

PJQ.views.auth.AppSignUp = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Sign-Up'),
		subscriptionId: null,
		affiliateId: null
	},
	events: {
		'click .btn-sign-up': 'signUp',
		'click .btn-sign-in-nav': 'signInNavigate',
		'keydown .input-password-signup': 'checkReady',
		'keydown .input-username-signup': 'checkReady'
	},
	beforeFirstRender: function () {
		PJQ.helpers.setViewport("width=device-width, initial-scale=1, minimum-scale=1");

		this.model = new PJQ.models.users.User();
		let sessionContact = PJQ.app.session.contact;
		if (sessionContact != null) {
			this.model.set({
				companyName: sessionContact.get('companyName'),
				contactName: sessionContact.get('contactName'),
				zip: sessionContact.get('zip'),
				email: sessionContact.get('email'),
				phone: sessionContact.get('phone')
			});
		}
		if (_.size(PJQ.helpers.urlHelpers.getQueryParam('bb')) > 0) {
			this.model.set('isBlueBook', true);
		}

		let portalOwner = PJQ.app.session.preferences.getPref('portalOwner');
		PJQ.app.session.fetchUserGroups(portalOwner ? portalOwner : 39, _.bind(function (groups) {
			this.groups = groups;
			this.render();
		}, this));
		return false;
	},
	renderData: function () {
		return {
			model: this.model,
			groups: this.groups,
			subscriptionId: this.options.subscriptionId > 1 ? this.options.subscriptionId : null
		};
	},
	afterRender: function () {
		if(this.options.affiliateId == null){
			this.options.affiliateId = PJQ.helpers.urlHelpers.getQueryParam('affiliateId');
		}
		new PJQ.Binder(this.$el, this.model, {
			watchElements: [
				'input'
			],
			afterChange: _.bind(function ($field, attr, val) {
				// this.validateField($field, attr, val);
			}, this)
		});

		PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.input-phone'));

		if (PJQ.app.session.get('portalId') === 4) {
			new PJQ.inputs.Selectpicker({
				el: this.$('.select-company-type'),
				noneSelectedText: 'Select Type',
				mobile: PJQ.helpers.mobile.getDevice() != null,
				onChange: _.bind(function (value) {
					this.model.set('companyType', value);
					if (value === 'SUB') {
						this.$('.groups-outer').removeClass('hidden');
					}
					else {
						this.$('.groups-outer').addClass('hidden');
					}
				}, this)
			});
		}

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-groups'),
			noneSelectedText: 'Select Trades',
			liveSearch: true,
			isIntChoices: true,
			isMultiple: true,
			header: '<div class="text-align-right"><button type="button" class="btn close position-relative text-dark op-10 fs-17 pt-2 mt-1 mb-1 mr-1">Done</button></div>',
			mobile: PJQ.helpers.mobile.getDevice() != null,
			onChange: _.bind(function (value) {
				this.model.set('groups', value);
			}, this),
			defaultValue: _.map(this.model.get('groups'), function (group) {
				return group.groupId;
			})
		});

		this.statePicker = new PJQ.inputs.Selectpicker({
			el: this.$('.input-country'),
			noneSelectedText: 'Select Value',
			defaultValue: 'us',
			onChange: _.bind(function (value) {
				this.model.set('country', value.toUpperCase());
				this.model.set('zip', '');
				this.countryChanged();
			}, this)
		});
		this.countryChanged();

		if (PJQ.app.session.isPanteraPortal()) {
			this.initFeatureAds();
		}
	},
	initFeatureAds: function () {
		let features = PJQ.helpers.auth.features();
		if (_.size(features) > 0) {
			let feature = features[Math.floor(Math.random() * _.size(features))];
			this.renderSubTemplate(false, feature, this.$('.app-sign-in-features'), {});
		}
	},
	validateField: function () {
		let isValid = true,
			isCompanyNameValid = _.size(this.model.get('companyName')) !== 0,
			isContactNameValid = _.size(this.model.get('contactName')) !== 0,
			isUsernameValid = _.size(this.model.get('username')) !== 0,
			isPasswordValid = _.size(this.model.get('password')) !== 0,
			isZipValid = _.size(this.model.get('zip')) >= 5,
			isPhoneValid = _.size(this.model.get('phone')) >= 10,
			isEmailValid = _.size(this.model.get('email')) !== 0,
			isCompanyTypeValid = _.size(this.model.get('companyType')) !== 0,
			isGroupsValid = _.size(this.model.get('groups')) !== 0

		PJQ.helpers.inputHelpers.setInputError(this.$('.input-company-name'), isCompanyNameValid);
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-contact-name'), isContactNameValid);
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-phone'), isPhoneValid);
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-email'), isEmailValid);
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-zip'), isZipValid);
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-username-signup'), isUsernameValid);
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-password-signup'), isPasswordValid);

		if (!isCompanyNameValid || !isContactNameValid || !isUsernameValid || !isPasswordValid || !isPhoneValid || !isEmailValid || !isZipValid) {
			this.renderError("Required fields missing data or incorrectly formatted.");
			isValid = false;
		}

		if (PJQ.app.session.get('portalId') === 4) {
			if (!isCompanyTypeValid) {
				this.renderError("Required fields missing data");
				isValid = false;
			}
			PJQ.helpers.inputHelpers.setInputError(this.$('.select-company-type'), isCompanyTypeValid);

			if (this.model.get('companyType') === 'SUB') {
				if (!isGroupsValid) {
					this.renderError('Required fields missing data');
					isValid = false;
				}
				PJQ.helpers.inputHelpers.setInputError(this.$('.select-groups'), isGroupsValid);
			}
		}

		return isValid;
	},
	countryChanged: function () {
		if (!this.model.get('country')) {
			this.model.set('country', 'US');
		}
		let country = _.size(this.statePicker.getValue()) > 0 ? this.statePicker.getValue().toLowerCase() : 'us',
			options = '<option value="">Select Value</option>';

		PJQ.helpers.inputHelpers.inputMaskZip(this.$('.input-zip'), country);
	},
	signInNavigate: function () {
		PJQ.app.router.signInNavigate();
	},
	checkReady: function (e) {
		if (e.keyCode === 13) {
			this.signUp()
		}
	},
	renderError: function (error) {
		this.$('.btn-sign-up').prop('disabled', false);
		this.errorAlert = new PJQ.Alert(this.$('.error-container'), {
			type: 'danger',
			text: error
		});
	},
	signUp: function () {
		if (this.errorAlert) {
			this.errorAlert.destroy();
		}

		if (!this.validateField()) {
			return;
		}

		this.$('.btn-sign-up').prop('disabled', true);

		let params = [];
		if (this.options.subscriptionId != null) {
			params.push({
				parameter: 'subscriptionId',
				value: this.options.subscriptionId
			});
		}
		if (this.options.affiliateId != null) {
			params.push({
				parameter: 'affiliateId',
				value: this.options.affiliateId
			});
		}
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'signup'
				}
			], params),
			data: this.model
		}).post().done(_.bind(function (data) {
			if (data.success) {
				PJQ.app.session.set('sessionId', data.sessionId);
				PJQ.helpers.cookieHelpers.setCookie(".DOTNETNUKE", data.cookie);
				PJQ.helpers.cookieHelpers.setCookie("SessionId", data.sessionId);
				if (PJQ.app.module === PJQ.constants.modules.APP) {
					let accessKey = PJQ.app.session.get('accessKey');
					if (_.size(accessKey) > 0) {
						PJQ.app.session.fetch({
							success: function () {
								PJQ.helpers.projectHelpers.accessKeyNavigate(accessKey, _.bind(function (err) {
									if (err != null) {
										this.renderError(err);
									}
								}, this));
							}
						});
					}
					else if(_.size(this.options.affiliateId) > 0){
						window.location = '/#settings/billing';
					}
					else {
						window.location.reload();
					}
				}
				else {
					window.location = '/';
				}
			}
			else {
				this.renderError(PJQ.Errors.auth[data.error]);
			}
		}, this)).fail(_.bind(function (xhr, err, result) {
			this.renderError(PJQ.Errors.auth.UNHANDLED);
			new PJQ.logging.Debug(PJQ.logging.LoggingActions.AUTH_SIGN_UP, {
				error: err,
				result: result
			});
		}, this));
	}
});

PJQ.views.auth.AppResetPassword = PJQ.views.auth.ResetPassword.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Reset-Password'),
		isRequirementsGrid: false
	}
});

PJQ.helpers.auth = {
	features: function () {
		return [
			// Commented out older screens in case we want to use them again.
			// new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Sign-In-Feature-Proqual'),
			// new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Sign-In-Feature-Plan-Express'),
			// new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Sign-In-Feature-Doc-Clerk'),
			// new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Sign-In-Feature-Cloud-Storage'),
			// new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Sign-In-Feature-Scheduling'),
			// new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Sign-In-Feature-Mobile'),
			// new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'App-Sign-In-Free-Trial'),
			new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'app-sign-in-carousel')

		];
	},
	validateSessionContact: function () {
		if (PJQ.app.session.contact != null && PJQ.app.session.contact.get('isDeleted')) {
			//Hide main app element, which is the outer element on all PJQ modules
			PJQ.app.$el.addClass('hidden');
			//Show dialog to tell user this link is no longer active
			new PJQ.views.modals.ErrorModal({
				header: 'Inactive Link',
				body: "This link is no longer active.",
				errorCode: PJQ.constants.errorCodes.DELETED_CONTACT
			});
			return true;
		}
	}
};